module.exports = __webpack_public_path__ + "img/wwsp.eb0db33a.png";